import { StatusCode } from "api/protocols";
import { GetTable, ITable } from "api/rpc/2024-04/facilityAdmin/tables/tables";

export async function getOpenTablesForUser(userId: number): Promise<ITable[]> {
  if (!userId) {
    return [];
  }

  const tablesResponse = await GetTable({}, false);

  if (tablesResponse.status !== StatusCode.OK || !tablesResponse.data) {
    return [];
  }

  return tablesResponse.data.filter(table => !!table.open && table.user_id === userId);
}
